if (!customElements.get("quick-filter")) {
  class QuickFilter extends HTMLElement {
    constructor() {
      super();
      this.select1 = this.querySelector(".js-filter-select-1");
      this.select2 = this.querySelector(".js-filter-select-2");
      this.select3 = this.querySelector(".js-filter-select-3");
      this.select4 = this.querySelector(".js-filter-select-4");
      this.button = this.querySelector(".js-filter-submit");
      this.minSearchItems = Number(this.dataset.searchMinItems);
      this.init = debounce(this.doInit.bind(this), 300);

      this.handleSelectChange = this.handleSelectChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);

      document.addEventListener("shopify:section:reorder", (evt) => {
        if (evt.target.contains(this)) {
          setTimeout(() => {
            this.destroy();
          }, 100);
          setTimeout(() => {
            this.init();
          }, 500);
        }
      });
    }

    connectedCallback() {
      if (window.sectionInstances.has(this)) return;
      window.sectionInstances.set(this, true);
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    destroy() {
      try {
        this.niceSelect1?.destroy();
      } catch (err) {}
      try {
        this.niceSelect2?.destroy();
      } catch (err) {}
      try {
        this.niceSelect3?.destroy();
      } catch (err) {}
      try {
        this.niceSelect4?.destroy();
      } catch (err) {}

      this.querySelectorAll(".nice-select").forEach((select) =>
        select.remove()
      );

      this.select1?.removeAttribute("style");
      this.select2?.removeAttribute("style");
      this.select3?.removeAttribute("style");
      this.select4?.removeAttribute("style");

      this.select1.removeEventListener("change", this.handleSelectChange);
      this.select2?.removeEventListener("change", this.handleSelectChange);
      this.select3?.removeEventListener("change", this.handleSelectChange);
      this.select4?.removeEventListener("change", this.handleSelectChange);
      this.button.removeEventListener("click", this.handleSubmit);
    }

    doInit() {
      this.select1.addEventListener("change", this.handleSelectChange);
      this.select2?.addEventListener("change", this.handleSelectChange);
      this.select3?.addEventListener("change", this.handleSelectChange);
      this.select4?.addEventListener("change", this.handleSelectChange);
      this.button.addEventListener("click", this.handleSubmit);

      requestAnimationFrame(() => {
        if (this.select1) {
          this.niceSelect1 = NiceSelect.bind(this.select1, {
            searchable:
              this.minSearchItems > 0 &&
              this.select1.options.length > this.minSearchItems,
            searchtext: window.accessibilityStrings.search,
          });
        }
        if (this.select2) {
          this.niceSelect2 = NiceSelect.bind(this.select2, {
            searchable: this.minSearchItems > 0,
            searchtext: window.accessibilityStrings.search,
          });
        }
        if (this.select3) {
          this.niceSelect3 = NiceSelect.bind(this.select3, {
            searchable: this.minSearchItems > 0,
            searchtext: window.accessibilityStrings.search,
          });
        }
        if (this.select4) {
          this.niceSelect4 = NiceSelect.bind(this.select4, {
            searchable: this.minSearchItems > 0,
            searchtext: window.accessibilityStrings.search,
          });
        }
      });
    }

    handleSubmit() {
      let url = null;
      if (this.select4?.selectedIndex > 0) {
        const selectedOption = this.select4.options[this.select4.selectedIndex];
        if (selectedOption.dataset.url && selectedOption.dataset.url !== "#") {
          url = selectedOption.dataset.url;
        }
      } else if (this.select3?.selectedIndex > 0) {
        const selectedOption = this.select3.options[this.select3.selectedIndex];
        if (selectedOption.dataset.url && selectedOption.dataset.url !== "#") {
          url = selectedOption.dataset.url;
        }
      } else if (this.select2?.selectedIndex > 0) {
        const selectedOption = this.select2.options[this.select2.selectedIndex];
        if (selectedOption.dataset.url && selectedOption.dataset.url !== "#") {
          url = selectedOption.dataset.url;
        }
      } else if (this.select1?.selectedIndex > 0) {
        const selectedOption = this.select1.options[this.select1.selectedIndex];
        if (selectedOption.dataset.url && selectedOption.dataset.url !== "#") {
          url = selectedOption.dataset.url;
        }
      }

      if (url) window.location.href = this.makeAbsoluteUrl(url);
    }

    makeAbsoluteUrl(url) {
      if (url.includes(window.location.origin)) return url;
      return window.location.origin + (url.startsWith("/") ? url : "/" + url);
    }

    handleSelectChange(event) {
      const currentSelect = event.target;
      const selectedOption = currentSelect.options[currentSelect.selectedIndex];
      if (!selectedOption.dataset.url || selectedOption.dataset.url === "#") {
        this.button.setAttribute("disabled", "disabled");
      } else {
        this.button.removeAttribute("disabled");
      }

      const nextSelect =
        currentSelect === this.select1
          ? this.select2
          : currentSelect === this.select2
          ? this.select3
          : currentSelect === this.select3
          ? this.select4
          : null;

      if (!nextSelect) return;

      const options = Array.from(nextSelect.options);
      let optionsShown = 0;

      options.slice(1).forEach((option) => {
        if (option.dataset.parentId === selectedOption.id) {
          optionsShown++;
          option.removeAttribute("disabled");
          option.removeAttribute("hidden");
        } else {
          option.setAttribute("hidden", "hidden");
          option.setAttribute("disabled", "disabled");
        }
      });

      nextSelect
        .closest(".quick-filter__select-container")
        ?.classList.toggle(
          "quick-filter__hide-search",
          optionsShown < this.minSearchItems
        );

      if (this.dataset.autoOpenNextDropdown) {
        requestAnimationFrame(() => {
          if (nextSelect === this.select2)
            this.querySelector(
              ".nice-select.js-filter-select-2:has(.option:not(:first-child):not(.disabled))"
            )?.click();
          if (nextSelect === this.select3)
            this.querySelector(
              ".nice-select.js-filter-select-3:has(.option:not(:first-child):not(.disabled))"
            )?.click();
          if (nextSelect === this.select4)
            this.querySelector(
              ".nice-select.js-filter-select-4:has(.option:not(:first-child):not(.disabled))"
            )?.click();
        });
      }

      if (optionsShown > 0) {
        nextSelect.removeAttribute("disabled");
      } else {
        nextSelect.setAttribute("disabled", "disabled");
      }

      nextSelect.querySelector("option")?.setAttribute("selected", "selected");
      if (this.select2 && nextSelect === this.select2) {
        if (this.select3)
          this.select3
            .querySelector("option")
            ?.setAttribute("selected", "selected");
        this.select3?.setAttribute("disabled", "disabled");
        this.niceSelect3?.update();
        if (this.select4)
          this.select4
            .querySelector("option")
            ?.setAttribute("selected", "selected");
        this.select4?.setAttribute("disabled", "disabled");
        this.niceSelect4?.update();
      }

      if (this.select2 && nextSelect === this.select2) {
        this.niceSelect2?.update();
      } else if (this.select3 && nextSelect === this.select3) {
        this.niceSelect3?.update();
      } else if (this.select4 && nextSelect === this.select4) {
        this.niceSelect4?.update();
      }
    }
  }

  customElements.define("quick-filter", QuickFilter);
}
